export default __webpack_public_path__ + "static/media/iconMarina.faa2d4f6.svg";